<script>
import { useMessageFormatter } from 'shared/composables/useMessageFormatter';
import { useAI } from 'dashboard/composables/useAI';
import { useAIFeedback } from 'dashboard/composables/useAIFeedback';
import AILoader from './AILoader.vue';
import NextButton from 'dashboard/components-next/button/Button.vue';

export default {
  components: {
    AILoader,
    NextButton,
  },
  props: {
    aiOption: {
      type: String,
      required: true,
    },
  },
  emits: ['close', 'applyText'],
  setup() {
    const { formatMessage } = useMessageFormatter();
    const { draftMessage, processEvent, recordAnalytics } = useAI();
    const { setPendingFeedback, isPendingFeedback } = useAIFeedback();
    return { 
      draftMessage, 
      processEvent, 
      recordAnalytics, 
      formatMessage,
      setPendingFeedback,
      isPendingFeedback,
    };
  },
  data() {
    return {
      generatedContent: '',
      isGenerating: true,
      conversationId: null,
      answerWasApplied: false,
    };
  },
  computed: {
    headerTitle() {
      const translationKey = this.aiOption?.toUpperCase();
      return translationKey
        ? this.$t(`INTEGRATION_SETTINGS.OPEN_AI.WITH_AI`, {
            option: this.$t(
              `INTEGRATION_SETTINGS.OPEN_AI.OPTIONS.${translationKey}`
            ),
          })
        : '';
    },
    // Показывать кнопку "Жалоба" только для reply_suggestion
    showReportButton() {
      return this.aiOption === 'reply_suggestion' && this.generatedContent && !this.isGenerating;
    },
  },
  mounted() {
    this.generateAIContent(this.aiOption);
    // Получаем conversationId из store
    this.conversationId = this.$store.getters.getSelectedChat?.id;
  },

  methods: {
    onClose() {
      this.$emit('close');
    },

    async generateAIContent(type = 'rephrase') {
      this.isGenerating = true;
      this.generatedContent = await this.processEvent(type);
      this.isGenerating = false;
    },
    applyText() {
      this.recordAnalytics(this.aiOption);
      this.$emit('applyText', this.generatedContent);
      this.onClose();
    },
    reportIncorrectAnswer() {
      if (!this.conversationId || !this.generatedContent) {
        return;
      }

      // Устанавливаем состояние "ожидание правильного ответа"
      this.setPendingFeedback(this.conversationId, this.generatedContent);

      // Показываем уведомление
      this.$store.dispatch('showAlert', {
        message: this.$t('INTEGRATION_SETTINGS.OPEN_AI.FEEDBACK_PENDING'),
        type: 'success',
      });

      this.onClose();
    },
  },
};
</script>

<template>
  <div class="flex flex-col h-full">
    <woot-modal-header :header-title="headerTitle" />
    <form
      class="flex flex-col flex-grow w-full modal-content"
      @submit.prevent="applyText"
    >
      <!-- <div v-if="draftMessage" class="w-full">
        <h4 class="mt-1 text-base text-n-slate-12">
          {{ $t('INTEGRATION_SETTINGS.OPEN_AI.ASSISTANCE_MODAL.DRAFT_TITLE') }}
        </h4>
        <p v-dompurify-html="formatMessage(draftMessage, false)" />
        <h4 class="mt-1 text-base text-n-slate-12">
          {{
            $t('INTEGRATION_SETTINGS.OPEN_AI.ASSISTANCE_MODAL.GENERATED_TITLE')
          }}
        </h4>
      </div> -->
      <div class="flex flex-col flex-grow overflow-auto">
        <AILoader v-if="isGenerating" />
        <p v-else v-dompurify-html="formatMessage(generatedContent, false)" />
      </div>

      <div class="flex flex-row justify-between w-full gap-2 px-0 py-2">
        <NextButton
          v-if="showReportButton"
          ruby
          solid
          type="button"
          icon="i-lucide-flag"
          :label="
            $t('INTEGRATION_SETTINGS.OPEN_AI.ASSISTANCE_MODAL.BUTTONS.REPORT')
          "
          @click.prevent="reportIncorrectAnswer"
        />
        <div v-else />
        <div class="flex flex-row gap-2">
          <NextButton
            faded
            slate
            type="reset"
            :label="
              $t('INTEGRATION_SETTINGS.OPEN_AI.ASSISTANCE_MODAL.BUTTONS.CANCEL')
            "
            @click.prevent="onClose"
          />
          <NextButton
            type="submit"
            :disabled="!generatedContent"
            :label="
              $t('INTEGRATION_SETTINGS.OPEN_AI.ASSISTANCE_MODAL.BUTTONS.APPLY')
            "
          />
        </div>
      </div>
    </form>
  </div>
</template>

<style lang="scss" scoped>
.modal-content {
  @apply pt-2 px-8 pb-8;
}

.container {
  width: 100%;
}
</style>
